import moment from "moment";
import React from "react";
import { Card, Segment, Header } from "semantic-ui-react";

const SwapLogging = ({ logs }) => {
  return (
    <Segment>
      <Header as="h2" dividing>
        Logs
      </Header>
      <Card.Group>
        {logs.map((log) => (
          <Card key={log.log_id} fluid>
            <Card.Content>
              <Card.Header> Function {log.function_name}</Card.Header>
              <Card.Description> Log ID: {log.log_id}</Card.Description>
              <Card.Description>
                {" "}
                Timestamp:{" "}
                {moment(log.created_at).format("DD-MM-YYYY HH:mm:ss")}
              </Card.Description>
            </Card.Content>
            <Card.Content>
              {log.events ? (
                <>
                  <Header as="h4">Events</Header>
                  <pre>{JSON.stringify(log.events, null, 2)}</pre>
                </>
              ) : null}

              {log.result ? (
                <>
                  <Header as="h4">Result</Header>
                  <pre>{JSON.stringify(log.result, null, 2)}</pre>
                </>
              ) : null}
              {log.error ? (
                <>
                  <Header as="h4">Error</Header>
                  <pre>{log.error}</pre>
                </>
              ) : null}
            </Card.Content>
          </Card>
        ))}
      </Card.Group>
    </Segment>
  );
};

export default SwapLogging;
